import { render, staticRenderFns } from "./reminderSetting.vue?vue&type=template&id=75cf34cf&scoped=true&"
import script from "./reminderSetting.vue?vue&type=script&lang=js&"
export * from "./reminderSetting.vue?vue&type=script&lang=js&"
import style1 from "./reminderSetting.vue?vue&type=style&index=1&id=75cf34cf&prod&lang=scss&scoped=true&"
import style2 from "./reminderSetting.vue?vue&type=style&index=2&id=75cf34cf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cf34cf",
  null
  
)

export default component.exports